import {
  DataRangeFilterEnum,
  getDataRangeFilterLabel,
  type DateRangeFilterOption,
} from '@/constants/dates';

/** Statement vault presets. */
export const statementsVaultDateFilters: DataRangeFilterEnum[] = [
  DataRangeFilterEnum.Trailing1Month,
  DataRangeFilterEnum.Trailing3Months,
  DataRangeFilterEnum.Trailing6Months,
  DataRangeFilterEnum.Trailing9Months,
  DataRangeFilterEnum.Trailing1Year,
  DataRangeFilterEnum.OpenYear,
  DataRangeFilterEnum.Trailing2Years,
  DataRangeFilterEnum.AllTime,
];

export const statementsVaultDateFilterOptions: DateRangeFilterOption[] =
  statementsVaultDateFilters.map((filter) => ({
    filter,
    label: getDataRangeFilterLabel(filter),
  }));

/**
 * Maps {@link DataRangeFilterEnum} to the Documents2 `DateInterval` param for statements.
 * API uses negative month counts (`Trailing1Year` → `-12`, `Trailing2Years` → `-24`).
 */
export function toStatementsDateIntervalApiValue(
  filter: DataRangeFilterEnum,
): string {
  switch (filter) {
    case DataRangeFilterEnum.Trailing1Month:
      return '-1';
    case DataRangeFilterEnum.Trailing3Months:
      return '-3';
    case DataRangeFilterEnum.Trailing6Months:
      return '-6';
    case DataRangeFilterEnum.Trailing9Months:
      return '-9';
    case DataRangeFilterEnum.Trailing1Year:
      return '-12';
    case DataRangeFilterEnum.OpenYear:
      return '0';
    case DataRangeFilterEnum.Trailing2Years:
      return '-24';
    case DataRangeFilterEnum.AllTime:
      return '';
    default:
      throw new Error(`Unsupported statements vault date filter: ${filter}`);
  }
}
